import { IndicatorT, LibraryIndicatorT } from 'business/definitions';

export const INDICATOR_TAG_TYPES = {
    chartType: 'chartType',
    connector: 'connector',
    metric: 'metric',
    title: 'title',
} as const;

export type IndicatorTagTypeT =
    (typeof INDICATOR_TAG_TYPES)[keyof typeof INDICATOR_TAG_TYPES];

export type IndicatorTagT = {
    aggregation?: string;
    value: string;
    type: IndicatorTagTypeT;
};

export type IndicatorFilterT<T extends string> = {
    value: T;
    name: string;
};

export function isCityIndicator(
    indicator: LibraryIndicatorT,
): indicator is IndicatorT {
    return 'dashboardSlug' in indicator;
}
